import ClientIndex, { loader as clientLoader } from '.';
import ClientEditProject, {
  loader as clientProjectLoader,
  action as clientProjectAction,
} from './pages/ClientProjectDetails';
import ClientLayout from './layouts/ClientLayout';
import ClientInbox from './pages/ClientInbox';
import ClientProjects from './pages/ClientProjects';
import ClientLibrary from './pages/ClientLibrary';
import ClientMedia from './pages/ClientMedia';
import ClientBranding from './pages/ClientBranding';
import ClientMusic from './pages/ClientMusic';
import ClientTeam from './pages/ClientTeam';
import ClientInvoices from './pages/ClientInvoices';
import ClientSupport from './pages/ClientSupport';
import ClientSettings from './pages/ClientSettings';

import CreateProjectLayout from './pages/ClientCreateProject/CreateProjectLayout';
import ProjectDetails from './pages/ClientCreateProject/ProjectDetails';
import Deliverables from './pages/ClientCreateProject/Deliverables';
import Review from './pages/ClientCreateProject/Review';
import ClientError from './components/ClientError';

export const clientRoutes = {
  path: 'client',
  element: <ClientLayout />,
  errorElement: <ClientError />,
  children: [
    {
      index: true,
      element: <ClientIndex />,
      loader: clientLoader,
    },
    {
      path: 'projects/create',
      element: <CreateProjectLayout />,
      children: [
        { index: true, element: <ProjectDetails /> },
        { path: 'deliverables', element: <Deliverables /> },
        { path: 'review', element: <Review /> },
      ],
    },
    {
      path: 'projects/:projectId',
      element: <ClientEditProject />,
      loader: clientProjectLoader,
      action: clientProjectAction,
    },
    { path: 'inbox', element: <ClientInbox /> },
    { path: 'projects', element: <ClientProjects /> },
    { path: 'library', element: <ClientLibrary /> },
    { path: 'media', element: <ClientMedia /> },
    { path: 'branding', element: <ClientBranding /> },
    { path: 'music', element: <ClientMusic /> },
    { path: 'team', element: <ClientTeam /> },
    { path: 'invoices', element: <ClientInvoices /> },
    { path: 'support', element: <ClientSupport /> },
    { path: 'settings', element: <ClientSettings /> },
    { path: '*', element: <div>Client 404 Not Found</div> },
  ],
};
